import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => ({
	dateTimes: data.map((d: string) => ({ label: d, value: d })),
});
